module.exports = __webpack_public_path__ + "media/bell.0f492205.mp3";